<template>
    <Teleport to="body">
        <div class="modal fade z:$(comment-modal-zindex)! {content:'';fixed:z:$(comment-modal-overlay-zindex);bg:#0000001A;top:0;left:0;w:full;h:full}::before" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title f:20!">選擇趴特</h3>
                        <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body p:32|64!">
                        <div class="r:100 b:1|solid|#CECECE px:16">
                            <form action="." class="flex ai:center" @submit.prevent="search">
                                <img alt="" class="inline w:20 mr:8" src="image/icon_header_search.svg" />
                                <input class="flex:1 py:16 outline:none" placeholder="搜尋趴特" type="search" v-model.trim="keyword" />
                            </form>
                        </div>
                        <div class="{mt:32}>div">
                            <div v-if="colleges?.length">
                                <div class="font:bold">大學生專屬</div>
                                <div class="
                                    {cursor:pointer;r:20;b:1|solid|#EBEBEB;p:21|16;f:18;lh:1.44;flex;ai:center;gap:8;mt:16}>div
                                    {flex:1}>div_.name
                                    {bg:#F1F6FC;pr:72;rel}>div.actived
                                    {abs;content:'';right:32;bottom:50%;translateY(50%);w:24;h:24;bg:url(image/part/icon_checked.svg)}>div.actived::after
                                ">
                                    <div :class="{ actived: college.id === id }" @click="select(college)" :key="college" v-for="(college) in colleges">
                                        <div class="name">{{ college.title }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parts?.length">
                                <div class="font:bold">熱門趴特</div>
                                <div class="
                                    {cursor:pointer;r:20;b:1|solid|#EBEBEB;p:21|16;f:18;lh:1.44;flex;ai:center;gap:8;mt:16}>div
                                    {flex:1}>div_.name
                                    {bg:#F1F6FC;pr:72;rel}>div.actived
                                    {abs;content:'';right:32;bottom:50%;translateY(50%);w:24;h:24;bg:url(image/part/icon_checked.svg)}>div.actived::after
                                ">
                                    <div :class="{ actived: part.id === id }" @click="select(part)" :key="part" v-for="(part) in parts">
                                        <img alt="" class="r:100 block w:36 h:36 bg:#efefef" :src="part.icon_url" />
                                        <div class="name">{{ part.title }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const colleges = ref();
    const parts = ref();
    const id = ref();
    const keyword = ref();

    const root = ref();

    let modal;

    const emit = defineEmits(["select"]);

    const search = () => {
        if (keyword.value) {
            api("api/part/search", { keyword: keyword.value }).then((res) => {
                if (res.success) {
                    colleges.value = res.data.colleges;
                    parts.value = res.data.parts;
                }
            });
        }
    };

    const select = (part) => {
        emit("select", part);

        modal.hide();
    }

    const show = (current) => {
        id.value = current;
        keyword.value = "";

        api("api/part/recent", { current }).then((res) => {
            if (res.success) {
                colleges.value = res.data.colleges.sort((a) => a.id === current ? 1 : 0);
                parts.value = res.data.parts.sort((a) => a.id === current ? -1 : 0);

                modal.show();
            }
        });
    }

    defineExpose({ show });

    onMounted(() => {
        modal = new bootstrap.Modal(root.value);
    });
</script>
